import Config from '../../config/Config'
import { mergeMap, map, catchError, withLatestFrom } from 'rxjs/operators'
import { of } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import { headersSelector } from '../auth/selectors'
import * as actions from './actions'
import { ofType } from 'redux-observable'
import queryString from '@promoboxx/query-string-babel'

export const getFacebookPages = (action$, state$) => {
  // Variables with $ indicate a stream...
  return action$.pipe(
    ofType(actions.GET_FACEBOOK_PAGES),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const headers = headersSelector(state) || action.payload.headers

      const params = {
        fields: action.payload.fields || [],
      }

      const queryParams = queryString.stringify(params, {
        arrayFormat: 'bracket',
        encode: true,
      })

      const settings = {
        method: 'GET',
        responseType: 'json',
        headers,
        url: `${Config.API_BASE}/v2/retailer_accounts/${action.payload.retailerAccountId}/facebook_pages?${queryParams}`,
      }

      return ajax(settings).pipe(
        map((payload) => {
          return {
            type: actions.GET_FACEBOOK_PAGES_FULFILLED,
            payload: {
              facebookPages: payload.response,
              retailerAccountId: action.payload.retailerAccountId,
            },
          }
        }),
        catchError((payload) => {
          return of({
            type: actions.GET_FACEBOOK_PAGES_REJECTED,
            payload: {
              error: payload.response,
              retailerAccountId: action.payload.retailerAccountId,
            },
          })
        }),
      )
    }),
    catchError((error) => {
      return of({
        type: actions.GET_FACEBOOK_PAGES_REJECTED,
        payload: { error },
      })
    }),
  )
}
